<template>
    <v-container
            fill-height
            style="height: calc(100vh - 58px);"
    >
        <v-layout align-center>
            <v-flex text-xs-center>
                <h1 class="display-2 primary--text">Sorry, 404</h1>
                <p>The page you were looking for does not exist</p>
                <v-btn
                        outlined
                        color="primary"
                        to="/"> Back
                </v-btn>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
    export default {
        name: 'page-404',
    }
</script>

